import { useQuery } from 'react-query';
import { wgApi } from '../../../../../../app/src/features/api/wgApi';
import { ConversationSession } from '../../../overview/types/OverviewTypes';

interface Response {
  items: ConversationSession[];
}

const getSessionsByConversationId = async (conversationId: string) => {
  const { data, isError } = await wgApi.get<Response>(
    `/v1/api/conversations/${conversationId}/sessions`,
  );
  if (isError) throw new Error();
  return data;
};

export const getSessionsByConversationIdQKey = (conversationId: string) => [
  'conversations',
  conversationId,
  'sessions',
];

export const useConversationSessions = (conversationId?: string) => {
  return useQuery(
    getSessionsByConversationIdQKey(conversationId!),
    () => getSessionsByConversationId(conversationId!),
    {
      enabled: !!conversationId,
    },
  );
};
